import StorePickerWrapper from 'components/GlobalModals/InventoryAwareStorePickerModal/StorePickerWrapper/StorePickerWrapper';
import { withStorePickerWrapperProps } from 'components/GlobalModals/InventoryAwareStorePickerModal/StorePickerWrapper/withStorePickerWrapperProps';

export default withStorePickerWrapperProps(StorePickerWrapper);
